// export const apiUrl = 'https://hagnos.tech/apibackend/apis/';
// export const assetsUrl = 'https://hagnos.tech/apibackend/assets/';

export const apiUrl = 'https://marketing.consulthagnos.in.net/apibackend/apis/';
export const assetsUrl = 'https://marketing.consulthagnos.in.net/apibackend/assets/';

// export const apiUrl = 'http://127.0.0.1:8000/apis/';
// export const assetsUrl = 'http://127.0.0.1:8000/assets/';